// ar translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const ar = {
    // Common
    "common.loading": "جار التحميل...",
    "common.save": "حفظ",
    "common.cancel": "إلغاء",
    "common.delete": "حذف",
    "common.edit": "تعديل",
    "common.submit": "إرسال",
    "common.logout": "تسجيل الخروج",
    "common.login": "تسجيل الدخول",
    "common.register": "التسجيل",
    
    // Auth
    "auth.welcome": "مرحباً",
    "auth.signIn": "سجل الدخول إلى حسابك",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.loginButton": "تسجيل الدخول",
    
    // Navigation
    "nav.dashboard": "لوحة التحكم",
    "nav.releases": "الإصدارات",
    "nav.payouts": "المدفوعات",
    "nav.support": "الدعم",
    "nav.referrals": "الإحالات",
    "nav.profile": "الملف الشخصي",
    
    // Dashboard
    "dashboard.welcome": "مرحباً",
    "dashboard.subtitle": "إدارة موسيقاك، تتبع إصداراتك وعرض أرباحك.",
    "dashboard.totalReleases": "إجمالي الإصدارات",
    "dashboard.totalTracks": "إجمالي المسارات",
    "dashboard.balance": "الرصيد الحالي",
    "dashboard.withdrawable": "قابل للسحب",
    "dashboard.recentReleases": "الإصدارات الأخيرة",
    "dashboard.newRelease": "إصدار جديد",
    "dashboard.requestPayout": "طلب دفع",
    
    // Analytics
    "analytics.title": "الإحصائيات",
    "analytics.subtitle": "تتبع أداء إصداراتك",
    "analytics.totalStreams": "إجمالي البث",
    "analytics.listeners": "المستمعون",
    "analytics.estimatedEarnings": "الأرباح المقدرة",
    "analytics.monthlyGrowth": "النمو الشهري",
    "analytics.streamsChart": "رسم بياني للبث",
    "analytics.platformDistribution": "توزيع المنصات",
    "analytics.topTracks": "المسارات الشائعة",
    "analytics.trackName": "اسم المسار",
    "analytics.streams": "بث",
    "analytics.comingSoonTitle": "قريباً جداً",
    "analytics.comingSoonDesc": "التحليلات التفصيلية والإحصائيات ستكون متاحة قريباً. مع تكامل artist.tools، ستتمكن من تتبع جميع بيانات المنصات في مكان واحد.",
    "common.comingSoon": "قريباً",
    
    // Payouts
    "payouts.title": "إدارة أرباحك",
    "payouts.subtitle": "اسحب أرباحك الموسيقية بسهولة. اطلب دفعة بحد أدنى 50$.",
    "payouts.fastPayment": "دفع سريع",
    "payouts.secureTransfer": "تحويل آمن",
    "payouts.totalBalance": "الرصيد الإجمالي",
    "payouts.withdrawableBalance": "قابل للسحب",
    "payouts.requestPayout": "طلب دفعة",
    "payouts.payoutHistory": "سجل الدفعات",
    "payouts.noPayouts": "لا توجد طلبات دفع بعد",
    "payouts.noPaymentMethod": "لا يوجد طريقة دفع",
    "payouts.addMethodDesc": "أضف طريقة دفع لسحب أرباحك.",
    "payouts.addMethod": "إضافة طريقة دفع",
    "payouts.changeMethodVerification": "التحقق عبر البريد الإلكتروني مطلوب لتغيير طريقة الدفع الحالية",
    "payouts.availableBalance": "الرصيد المتاح",
    "payouts.pendingBalance": "الرصيد المعلق",
    "payouts.withdrawalHistory": "سجل السحب",
    "payouts.requestWithdrawal": "طلب سحب",
    "payouts.minWithdrawal": "الحد الأدنى للسحب: 50$",
    "payouts.manageEarnings": "إدارة أرباحك",
    "payouts.createRequest": "إنشاء طلب دفع",
    "payouts.amount": "المبلغ",
    "payouts.accountHolder": "صاحب الحساب",
    "payouts.bankName": "اسم البنك",
    "payouts.minAmount": "الحد الأدنى للسحب هو 50$",
    "payouts.insufficientBalance": "رصيد غير كافٍ",
    "payouts.fillRequired": "يرجى ملء جميع الحقول المطلوبة",
    "payouts.requestCreated": "تم إنشاء طلب الدفع",
    "payouts.requestFailed": "فشل الطلب",
    "payouts.minNotMet": "لم يتم الوصول للحد الأدنى",
    "payouts.minNotMetMsg": "تحتاج إلى 50$ على الأقل من الرصيد القابل للسحب لطلب دفعة.",
    "payouts.statusRequested": "مطلوب",
    "payouts.statusPaid": "مدفوع",
    "payouts.paymentMethod": "طريقة الدفع",
    "payouts.bankTransfer": "تحويل بنكي",
    "payouts.paypalEmail": "بريد PayPal",
    "payouts.paypalNote": "أدخل عنوان البريد الإلكتروني المرتبط بحساب PayPal الخاص بك",
    "payouts.fillPaypalRequired": "يرجى إدخال بريد PayPal واسم صاحب الحساب",
    "payouts.selectCountry": "اختر بلدك",
    "payouts.tabProfile": "ملف الدفع",
    "payouts.tabMethod": "طريقة الدفع",
    "payouts.tabRequests": "طلبات السحب",
    "payouts.requirements": "متطلبات السحب",
    "payouts.completeProfile": "أكمل ملف الدفع الخاص بك (الهوية والعنوان)",
    "payouts.addPaymentMethod": "أضف طريقة دفع (بنك أو PayPal)",
    "payouts.verifyPaymentMethod": "تحقق من طريقة الدفع الخاصة بك",
    "payouts.profileComplete": "مكتمل",
    "payouts.savedProfile": "معلومات الملف المحفوظة",
    "payouts.fullName": "الاسم الكامل",
    "payouts.phoneNumber": "رقم الهاتف",
    "payouts.location": "الموقع",
    "payouts.profileType": "نوع الملف",
    "payouts.individual": "فردي",
    "payouts.business": "شركة/عمل",
    "payouts.edit": "تعديل",
    
    // Statuses
    "status.draft": "مسودة",
    "status.submitted": "مُرسل",
    "status.approved": "موافق عليه",
    "status.rejected": "مرفوض",
    "status.live": "مباشر",
    
    // Validation
    "validation.audioRequired": "ملف الصوت مطلوب",
    "validation.audioFormatWav": "يجب أن يكون ملف الصوت بتنسيق WAV أو FLAC",
    "validation.titleRequired": "العنوان مطلوب",
    "validation.titleLanguageRequired": "لغة العنوان مطلوبة",
    "validation.primaryArtistRequired": "مطلوب فنان رئيسي واحد على الأقل",
    "validation.primaryGenreRequired": "اختيار النوع الرئيسي مطلوب",
    "validation.explicitRequired": "اختيار نوع المحتوى مطلوب",
    "validation.coverRequired": "صورة الغلاف مطلوبة",
    "validation.songwriterRequired": "مطلوب كاتب أغاني واحد على الأقل",
    "validation.contributorRequired": "مطلوب مساهم واحد على الأقل",
    "validation.productionTeamRequired": "مطلوب عضو واحد من فريق الإنتاج على الأقل",
    "validation.platformRequired": "يجب اختيار منصة واحدة على الأقل",
    "validation.releaseDateRequired": "تاريخ الإصدار مطلوب",
    "validation.trackCountRequired": "مطلوب مسارين على الأقل للـ EP/ألبوم",
    "releases.track": "مسار",
    
    // Toast Messages
    "toast.saveSuccess": "تم الحفظ بنجاح",
    "toast.saveFailed": "فشل الحفظ",
    "toast.deleteSuccess": "تم الحذف بنجاح",
    "toast.uploadSuccess": "تم الرفع بنجاح",
    "toast.submitSuccess": "تم الإرسال بنجاح",
    "toast.loginSuccess": "تم تسجيل الدخول بنجاح",
    "toast.copySuccess": "تم النسخ إلى الحافظة",
    "toast.errorOccurred": "حدث خطأ",
    "toast.pleaseFixErrors": "يرجى إصلاح الأخطاء في هذا القسم",
    
    // Spotify
    "spotify.comingSoon": "قريباً",
};

export default ar;
